import React, { createContext, useContext, useState } from 'react';
import {
  ILanguageProviderProps,
  ILocale,
  DefaultLanguage,
  LanguageObject,
  LANGUAGES,
} from './types';
import { getCookie } from 'commonUtils/src/getCookie';

const initialState: ILocale = {
  locale: DefaultLanguage,
  setLocale: () => {},
};

const LanguageContext = createContext<ILocale>(initialState);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const LanguageProvider = ({ children }: ILanguageProviderProps) => {
  const psLocale = getCookie('PS_Locale');
  const cookieLanguage = psLocale === 'es-US' ? LANGUAGES.es : LANGUAGES.en;

  const [locale, setLocale] = useState<LanguageObject>(cookieLanguage);

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
